import { StyledSpinner } from './styledComponents';

export const Spinner = () => (
  <StyledSpinner>
    <div className='loadingio-spinner-spinner-vhpwil6ajrj'>
      <div className='ldio-kudgc4zgrv'>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </StyledSpinner>
);
